export default __webpack_public_path__ + "static/media/Carepool_logo.272c4160.png";